import { render, staticRenderFns } from "./serviceActivityList.vue?vue&type=template&id=4338a7e2&scoped=true&"
import script from "./serviceActivityList.vue?vue&type=script&lang=js&"
export * from "./serviceActivityList.vue?vue&type=script&lang=js&"
import style0 from "./serviceActivityList.vue?vue&type=style&index=0&id=4338a7e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4338a7e2",
  null
  
)

component.options.__file = "serviceActivityList.vue"
export default component.exports